import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import { ENV } from '@/config'
import router from '@/router'
import { showNotification, NotificationType } from '@/utils/Notification'
import store from '@/store'
import UserStorage from '@/utils/Storage/UserStorage'
import { HTTPCode } from '@/store/types'

const baseURL = ENV.baseUrl
axios.defaults.baseURL = baseURL
axios.defaults.headers.common['Content-Type'] = 'application/json'

const userStorage = UserStorage.getInstance()

import firebase from 'firebase/app'
import 'firebase/auth'

/*
axios.interceptors.request.use(
  async function (config) {
    const user = userStorage.getObject()
    let actualDate = new Date().getTime()

    if (user && user?.expireToken && user?.expireToken <= actualDate) {
      await store.dispatch('signIn/googleRefrehToken', null, { root: true })
    }

    return config
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error)
  }
)*/

axios.interceptors.request.use(
  async function (config) {
    const user = firebase.auth().currentUser

    if (user) {
      try {
        const token = await user.getIdToken(true) // fuerza token actualizado
        config.headers.Authorization = `Bearer ${token}`
      } catch (err) {
        console.error('Error al obtener el token:', err)
        // opcional: puedes redirigir o forzar logout aquí si falla
      }
    }

    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)

axios.interceptors.response.use(
  function (response) {
    return response
  },

  async function (error) {
    const currentRoute = router.currentRoute.path
    if (
      error?.response?.status === HTTPCode.Unauthorized &&
      currentRoute !== '/'
    ) {
      //await store.dispatch('signIn/googleRefrehToken', null, { root: true })
      // showNotification(
      //   NotificationType.DANGER,
      //   'Tu sesión ha expirado, seras direccionado a la pantalla de login para que vuelvas a acceder',
      //   3000
      // )
      // setTimeout(() => {
      //   store.dispatch('signout')
      // }, 1500)
      store.dispatch('signout', null)
    } else if (currentRoute == '/validate') {
      if (
        error?.response?.data?.message == 'No se encontró el doctor buscado'
      ) {
        return {
          data: { succeeded: false, message: error?.response?.data?.message }
        }
      } else {
        showNotification(
          NotificationType.DANGER,
          'Error al conectar con los servicios de Lumine',
          4000
        )
        console.log(error)
        setTimeout(() => {
          store.dispatch('signout')
        }, 2500)

        return {
          data: { succeeded: false, message: error?.response?.data?.message }
        }
      }
    } else if (error?.response?.status === HTTPCode.NotFound) {
      const user = userStorage.getObject()
      const excludedPaths = ['/validate', '/register', '/request-status']
      const isPathExcluded = excludedPaths.includes(currentRoute)

      if (user == null && !isPathExcluded) {
        showNotification(
          NotificationType.DANGER,
          'Error al conectar con los servicios de Lumine',
          4000
        )
        console.log(error)
        setTimeout(() => {
          store.dispatch('signout')
        }, 2500)

        return {
          data: { succeeded: false, message: error?.response?.data?.message }
        }
      }
    } else if (error?.code == 'ERR_NETWORK') {
      showNotification(
        NotificationType.DANGER,
        'Error al conectar con los servicios de Lumine',
        4000
      )
      console.log(error)
      setTimeout(() => {
        store.dispatch('signout')
      }, 2500)

      return {
        data: { succeeded: false, message: error?.response?.data?.message }
      }
    } else if (error?.response?.status === HTTPCode.BadRequest) {
      if (
        error?.response?.data?.message !==
        'El dispositivo ya se había registrado anteriormente.'
      ) {
        console.log(error?.response?.data?.message)
        showNotification(
          NotificationType.DANGER,
          error?.response?.data?.message,
          2000
        )
      }

      return {
        data: { succeeded: false, message: error?.response?.data?.message }
      }
    }
  }
)

Vue.use(VueAxios, axios)
